<template>

    <div>

        <!-- Top navbar -->
        <modal-header
            :title="'Help Center'"
            :right="'close'">

            <template v-slot:leftComponent>
                <span class="asset-icon asset-icon--modal-header icon-green-help"></span>
            </template>

        </modal-header>

        <!-- Loading animation -->
        <lottie class="loading-animation" :options="{animationData: $root.loadAnimation}" v-if="initLoad"/>

        <!-- Main content -->
        <main-div v-if="!initLoad">

            <div class="mt-6">
                <!-- FOR, CATEG PARENT -->
                <div v-for="(group, key) in faqs" :key="key" class="pb-4 faq-group">
                    <h4 class="font-weight-bolder font-md">{{ group.title }}</h4>
                    <ul class="m-0">
                        <li v-for="(question, key) in group.faqRatings" @click="$emit('changeContent', {page: 'details', id: question.id})" :key="key" class="font-md d-block py-2">
                            {{ question.title }}
                        </li>
                    </ul>
                    <div class="divider-sm mt-4"></div>
                </div>
                <!-- END OF CATEG PARENT -->
            </div>

        </main-div>

    </div>

</template>

<script>
    export default {

        data: function () {
            return {
                initLoad: true,
                faqs: [],
            }
        },

        created: function() {
            axios
                .get("faqs")
                .then(response => {
                    this.initLoad = false
                    this.faqs = response.data
                })
        }
    }
</script>
